import React from 'react';
import ArrowUp from './ArrowUp';
const ArrowUpXS = ({ color, ...props }) => (React.createElement(ArrowUp, Object.assign({ color: color, size: 16 }, props)));
ArrowUpXS.displayName = 'ArrowUpXS'; // Fix for tsc
export default ArrowUpXS;
//# sourceMappingURL=ArrowUpXS.js.map